import { createFileRoute } from '@tanstack/react-router';

import { EligibilityPage } from '@/features/claims';
export const Route = createFileRoute('/_authenticated/eligibility/')({
  component: EligibilityPage,
  beforeLoad: () => ({ breadcrumbs: [{ href: '/eligibility', title: 'Eligibility & benefits' }] }),
});
